// Customer journey stage + health helpers

export type HealthLevel = "Healthy" | "Needs Attention" | "At Risk";

export interface Stage {
  key: string;
  label: string;
}

export interface CustomerLike {
  milestones?: {
    kickoff_call_1_done?: boolean;
    kickoff_call_2_done?: boolean;
    cocoach_planned?: boolean;
    cocoach_next_date?: string | null;
  };
}

export const STAGES: Stage[] = [
  { key: "first_week", label: "First week delivery" },
  { key: "onboarding", label: "Onboarding" },
  { key: "in_traject", label: "In traject" },
  { key: "last_mile", label: "Last mile" },
  { key: "afgerond", label: "Afgerond" },
  { key: "geen_traject", label: "Geen traject" },
];

export function healthBadge(level?: string): string {
  switch (level) {
    case "Healthy":
      return "bg-emerald-50 text-emerald-700 border-emerald-200";
    case "Needs Attention":
      return "bg-amber-50 text-amber-700 border-amber-200";
    case "At Risk":
      return "bg-red-50 text-red-700 border-red-200";
    default:
      return "bg-slate-100 text-slate-500 border-slate-200";
  }
}

export function initials(name = ""): string {
  return name
    .split(" ")
    .map((n) => n[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export const PRODUCTS: string[] = [
  "Dividend Jaartraject",
  "Dividend Halfjaartraject",
  "Dividend Formule",
  "Dividend Een-op-een traject",
  "CFP upgrade",
  "Membership",
  "Cashflow plan",
  "Start workshop",
];

export const CALL_TYPES: string[] = [
  "Kennismaking Coach",
  "Kick-off Call 1",
  "Kick-off Call 2",
  "APK check-in",
  "Online coaching",
  "Afrondend coach gesprek",
  "Co-coach Call",
  "Ad-hoc Call",
  "Sales handoff",
  "Online call",
  "Fysieke afspraak",
  "Matchcall",
  "Co-workdag",
  "Livedag",
  "Workshop",
];

export const SENTIMENTS: string[] = ["Positive", "Neutral", "Concerned", "At Risk"];

export const CUSTOMER_TYPES: { value: string; label: string }[] = [
  { value: "B2C", label: "B2C (particulier)" },
  { value: "B2B", label: "B2B (ondernemer)" },
];

export function fmtEuro(v: number | string | null | undefined): string {
  if (v == null || v === "") return "—";
  return new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(Number(v));
}

export function gmailComposeUrl(to?: string, subject?: string, body?: string): string {
  const params = new URLSearchParams({ view: "cm", fs: "1", to: to || "", su: subject || "", body: body || "" });
  return `https://mail.google.com/mail/?${params.toString()}`;
}
